.root {
  & {
    outline: none;
  }

  &.isSuffixFixedSize {
    .suffix {
      width: 24px;
      height: 24px;
    }
  }

  &:not(.disabled) {
    cursor: pointer;
  }
  
  .content {
    flex-grow: 1;
  }

  .inner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: var(--theme--sizing--05x) var(--theme--sizing--1x);
    border-radius: var(--theme--tokens--input--radius);
    background: transparent;
    transition: background var(--theme--transition--default);
    color: var(--option-item--text-color);
  }

  &.selected:not(.disabled),
  &:hover:not(.disabled) {
    .inner {
      background: var(--option-item--hover-background);
      color: var(--option-item--hover-text-color);
    }
  }

  &.focused:not(:hover):not(.disabled):not(.selected),
  &:focus-visible:not(:hover):not(.disabled):not(.selected) {
    .inner {
      outline: var(--theme--sizing--05x) solid var(--option-item--hover-background);
    }
  }

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: var(--theme--color--grey--dark);
  }
}
